export default __webpack_public_path__ + "static/media/Snd_LowerNSwim.e8abb30a.mp3";